import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { UserProfileDTO } from '../../models/user-profile.model';
import { AvatarComponent } from '../avatar/avatar.component';

const FEHLT = '–';
const ADMIN_ROLLEN = ['PLATFORM_ADMIN', 'TENANT_ADMIN'];
// Sprachen stehen in ihrer Eigenbezeichnung, unabhängig von der Oberflächensprache.
const SPRACHNAMEN: Record<string, string> = { de: 'Deutsch', en: 'English' };

function datumIn(zeitpunkt: Date, timeZone: string): string {
  return new Intl.DateTimeFormat('de-DE', { timeZone, day: '2-digit', month: '2-digit', year: 'numeric' }).format(
    zeitpunkt,
  );
}

function mitgliedSeit(createdAt: string | undefined, zeitzone: string | undefined): string {
  if (!createdAt) return FEHLT;
  const zeitpunkt = new Date(createdAt);
  if (Number.isNaN(zeitpunkt.getTime())) return FEHLT;
  try {
    return datumIn(zeitpunkt, zeitzone || 'UTC');
  } catch {
    return datumIn(zeitpunkt, 'UTC');
  }
}

@Component({
  selector: 'app-konto-profilkopf',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AvatarComponent, MatIcon, RouterLink, TranslatePipe],
  templateUrl: './konto-profilkopf.component.html',
  styleUrl: './konto-profilkopf.component.scss',
})
export class KontoProfilkopfComponent {
  readonly profil = input.required<UserProfileDTO>();

  protected readonly rolle = computed(() => (ADMIN_ROLLEN.includes(this.profil().role) ? this.profil().role : 'USER'));

  protected readonly sprache = computed(() => {
    const sprache = this.profil().language;
    return sprache ? (SPRACHNAMEN[sprache] ?? sprache) : FEHLT;
  });

  protected readonly zeitzone = computed(() => this.profil().timezone || FEHLT);

  protected readonly mitgliedSeit = computed(() => mitgliedSeit(this.profil().createdAt, this.profil().timezone));
}
